import { useFormikContext } from 'formik'
import { useEffect, useMemo } from 'react'

import { hasTokenizedCardParams } from '@pages/Traders-Room/Deposit/CardDetails/helpers'

import { useAccountReadContext } from '@context/AccountContextContext'

import { DepositFormValues } from '../../DepositFlowLayout/types'
import { getCardholderFieldName } from '../../helpers'

export const useEnsureCardholderName = (): void => {
  const { account } = useAccountReadContext()
  const { values, setFieldValue } = useFormikContext<DepositFormValues>()

  const nameOfAccountField = useMemo(
    () => getCardholderFieldName(values?.paymentProvider),
    [values?.paymentProvider]
  )

  const defaultName = useMemo(() => {
    return [account?.firstname, account?.lastname].filter(Boolean).join(' ').trim()
  }, [account?.firstname, account?.lastname])

  const tokenizedEnabled = hasTokenizedCardParams(values.paymentProvider?.parameters?.form)

  useEffect(() => {
    if (tokenizedEnabled || !defaultName) return

    const current = String(values?.fields?.[nameOfAccountField] ?? '').trim()
    if (current) return

    setFieldValue(`fields.${nameOfAccountField}`, defaultName, false)
  }, [
    nameOfAccountField,
    defaultName,
    tokenizedEnabled,
    values.paymentProvider.id,
    values?.fields,
    setFieldValue,
  ])
}
